<div class="responsive-container">
<bpc-generic-listing [enableSelection]="true " [hideTable]="dataView === 'chart'" [title]="'Interactions'" [columns]="interactionColumns" [companiesFilter]="interactionFilter"
    [hasPod]="true" [barType]="HorizontalBarType.Interaction" [data]="interactions" [totalCount]="totalCount"
    [isLoading]="isLoading" (onFilterChange)="onFilterChange($event)" (onLoadMore)="loadMoreData()" (onSelectionChange)="onCheckboxSelectionChange($event)">
    <div slot="header-options" class="col flex align-content-center flex-wrap flex-w-auto">
      <div class="col flex align-content-center flex-wrap flex-w-auto">
        <button (click)="toggleDataView('table')" [class.bg-orange-500]="dataView === 'table'"
          [class.text-white]="dataView === 'table'"
          class="px-3 py-2 text-orange-500 border-orange-500 border-1 button-radius-left">
          <i class="pi pi-table"></i>
        </button>
        <button style="margin-left: -2px;" (click)="toggleDataView('chart')"
          [class.bg-orange-500]="dataView === 'chart'" [class.text-white]="dataView === 'chart'"
          class="px-3 py-2 bg-orange-500 border-orange-500 border-1 text-orange-500 button-radius-right">
          <i class="pi pi-chart-bar"></i>
        </button>
      </div>
      <div class="col flex align-content-center flex-wrap flex-w-auto">
        <button
          class="btn-download"
          [disabled]="selectedRows.length === 0"
          (click)="onDownloadClick()"
        >
          <span class="icon-download mr-2"></span>
          Download CSV
        </button>
      </div>
    </div>
    <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto" *ngIf="!isMobile">
      <ng-container *ngFor="let subroute of subRoutes">
        <a class="vote-tab-buttons" [routerLink]="subroute.route" [ngClass]="{ 'active': subroute.active }">
          {{subroute.label}}
        </a>
      </ng-container>
      <a
        class="lbl-clear-filter"
        title="Clear All"
        (click)="clearAllFilters()"
        style="margin-top: 10px;"
        *ngIf="isFilterApplied"
        >Clear All</a
      >
    </div>
  </bpc-generic-listing>

  <ng-container *ngIf="dataView === 'chart'">
    <bpc-interaction-scatter-chart *ngIf="dataView === 'chart'" [interactionFilter]="interactionFilter" />
  </ng-container>
</div>